import React from 'react'

import { Button } from '@frame/ui-primitives/button'
import { Card } from '@frame/ui-primitives/card'
import { H4 } from '@frame/ui-primitives/h4'
import { P } from '@frame/ui-primitives/p'

import { INCOME_CARD_CONFIG } from '@frame/lib/constants'
import { IncomeType } from '@frame/lib/types'

type Props = {
  incomeType: IncomeType
  onClick?: () => void
}

export function AddIncomeCard({ incomeType, onClick }: Props) {
  const { title, desc, button, dataCy } = INCOME_CARD_CONFIG[incomeType]
  const intent = incomeType === IncomeType.OTHER ? 'secondary' : 'primary'

  return (
    <Card className="p-5" intent={intent}>
      <H4 className="mb-2">{title}</H4>
      <P variant="small" className="mb-4">
        {desc}
      </P>
      <Button data-cy={dataCy} intent={button.variant} onClick={onClick} applyCobranding={intent === 'primary'}>
        {button.text}
      </Button>
    </Card>
  )
}
